export const CONFIG = {
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  INVENTIA_BASE_URL: process.env.REACT_APP_INVENTIA_BASE_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  FE_URL: process.env.REACT_APP_FE_URL,
  ID_CONTO: process.env.REACT_APP_ID_CONTO,
  TOTEM_TIMEOUT_SECONDS: process.env.REACT_APP_TOTEM_TIMEOUT_SECONDS,
  TOTEM_TIMEOUT_SECONDS_ALERT: process.env.REACT_APP_TOTEM_TIMEOUT_SECONDS_ALERT,
};
